"use client"
import React, { useState } from 'react'
import BreadCrumbs from '../common/bread-crumbs'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs'
import ForMyself from './for-myself-form'
import SomeoneElseForm from './someone-else-form'
import MultiStepForm from './multi-step-form-self'
import MultiStepFormOthers from './multi-step-from-others'
import ThankYou from './thank-you'


function BookAppointment({doctor,speciality,location,param, crumbs, lang, appointmentBooking}) {
    // console.log(doctor,speciality,location);
    // const [activeValue, SetActiveValue] = useState('for myself');
    
    
    return (
        <>
            <BreadCrumbs lang={lang} crumbs={crumbs}/>
           
            <div className='custom-container bg-primaryBlue rounded-3xl md:px-8 px-2 py-6 mb-10'>
                <h1 className='text-primaryWhite header-sub mb-4'>{appointmentBooking.title}</h1>
                <Tabs defaultValue="for myself" >
                    <TabsList className='bg-blue-50 h-8 rounded-3xl xl:w-[32%] md:w-[310px] lg:w-[420px] flex flex-row justify-around'>
                        <TabsTrigger value="for myself"
                            className={`h-6 rounded-3xl w-1/2 data-[state=active]:bg-primaryBlue data-[state=active]:text-primaryWhite`}
                            // onClick={() => SetActiveValue('for myself')}
                            >{appointmentBooking.formforself}</TabsTrigger>
                        <TabsTrigger value="for someone else" className='h-6 rounded-3xl w-1/2 data-[state=active]:bg-primaryBlue data-[state=active]:text-primaryWhite'
                            // onClick={() => SetActiveValue('for someone else')}
                        >{appointmentBooking.forOthers}</TabsTrigger>
                    </TabsList>
                    
                    <div className="md:block hidden">
                        <TabsContent value='for myself' >
                            <ForMyself appointmentBooking={appointmentBooking} doctor={doctor} speciality={speciality} location={location} data={param} lang={lang} />
                        </TabsContent>
                        <TabsContent value='for someone else'>
                            <SomeoneElseForm appointmentBooking={appointmentBooking} doctor={doctor} speciality={speciality} location={location} data={param} lang={lang} />
                        </TabsContent>
                    </div>
                    {/* mobile step form */}
                    <div className='md:hidden block'>
                        <TabsContent value='for myself'>
                            <MultiStepForm appointmentBooking={appointmentBooking} doctor={doctor} speciality={speciality} location={location} data={param} lang={lang} />
                        </TabsContent>
                        <TabsContent value='for someone else'>
                            <MultiStepFormOthers appointmentBooking={appointmentBooking} doctor={doctor} speciality={speciality} location={location} data={param} lang={lang}/>
                        </TabsContent>
                    
                    </div>
                </Tabs>
            </div>
            
        </>
    )
}

export default BookAppointment
